export default [
    {
        path:'/replenish',
        name:'replenish',
        component:() => import('./replenish.vue'),
    }
]